import React from 'react';
import { Textfit } from 'react-textfit';
import { bodyFontSizesBOH, getDescription, titleFontSizesBOH } from '../../../helpers/utils';
import { usePager } from '../../../helpers/pagination';
import PageIndicator from '../../Common/PageIndicator';
import SideBar from '../../Common/SideBar';
import Row from './Row';
import './AvgTicket.scss';
const text_description = 'average check price';
const AvgTicket = ({
  metadata,
  data,
  duration,
  playing,
  text
}) => {
  var _metadata$accent_colo, _metadata$results, _data$top$slice, _data$top, _metadata$hide_powere;
  const {
    boh_period,
    boh_date_range,
    boh_event_type
  } = metadata;
  const {
    timezone,
    last_row: last_date
  } = data;
  const accent_color = (_metadata$accent_colo = metadata.accent_color) !== null && _metadata$accent_colo !== void 0 ? _metadata$accent_colo : '#000';
  const logo = metadata.logo;
  const results = (_metadata$results = metadata.results) !== null && _metadata$results !== void 0 ? _metadata$results : 10;
  const ranking = (_data$top$slice = (_data$top = data.top) === null || _data$top === void 0 ? void 0 : _data$top.slice(0, results)) !== null && _data$top$slice !== void 0 ? _data$top$slice : [];
  const own = data.own;
  const isOwnInRanking = (own === null || own === void 0 ? void 0 : own.ranking) <= results;
  const [page, pageIdx, pages] = usePager(ranking, duration * 1000, playing);
  const hide_poweredbyupshow = (_metadata$hide_powere = metadata.hide_poweredbyupshow) !== null && _metadata$hide_powere !== void 0 ? _metadata$hide_powere : true;
  const description = getDescription(timezone, boh_event_type, boh_period, boh_date_range, text_description, last_date);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "avg-ticket-container",
    style: {
      color: text.body_color,
      fontFamily: text.body_font_family,
      fontSize: bodyFontSizesBOH.medium
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "width-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "title",
    style: {
      color: text.title_color,
      fontFamily: text.title_font_family,
      fontSize: titleFontSizesBOH.medium
    }
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'title' + text.title_font_family,
    mode: "single",
    min: titleFontSizesBOH.small,
    max: titleFontSizesBOH.large
  }, text.title)), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, description)), /*#__PURE__*/React.createElement("div", {
    className: "avg-ticket-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-row list-header",
    style: {
      backgroundColor: accent_color,
      color: text.accent_color,
      fontFamily: text.title_font_family
    }
  }, /*#__PURE__*/React.createElement("p", null, "Location"), /*#__PURE__*/React.createElement("p", null, "Dollar Amount")), page.map((loc, index) => /*#__PURE__*/React.createElement(Row, {
    key: `${loc.location}=${index}`,
    location: loc,
    own: own,
    accent_color: accent_color
  })), !!own && !isOwnInRanking && /*#__PURE__*/React.createElement(Row, {
    key: `${own.location}`,
    location: own,
    own: own,
    accent_color: accent_color
  })), pages.length > 1 && /*#__PURE__*/React.createElement(PageIndicator, {
    pages: pages,
    current: pageIdx,
    selectedColor: accent_color
  }))), /*#__PURE__*/React.createElement(SideBar, {
    accent_color: accent_color,
    accent_text_color: text.accent_color,
    logo: logo,
    text: text.message_board,
    fontFamily: text.title_font_family,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default AvgTicket;